import React from 'react';
import './StyleSelector.css';

const StyleSelector = ({ selectedStyle, onStyleSelect }) => {
  const styles = [
    {
      id: 'ghibli',
      name: '吉卜力风格',
      imageUrl: 'https://i.imgur.com/JYt6Uhy.jpg'
    },
    {
      id: 'pixel',
      name: '像素风格',
      imageUrl: 'https://i.imgur.com/QsDFRJ3.jpg'
    },
    {
      id: 'sketch',
      name: '铅笔素描风格',
      imageUrl: 'https://i.imgur.com/k7bpBm4.jpg'
    }
  ];

  return (
    <div className="style-selector">
      <h3>选择转换风格</h3>
      <div className="style-options">
        {styles.map(style => (
          <div 
            key={style.id}
            className={`style-option ${selectedStyle === style.id ? 'selected' : ''}`}
            onClick={() => onStyleSelect(style.id)}
          >
            <div className="style-image">
              <img src={style.imageUrl} alt={style.name} />
            </div>
            <div className="style-name">{style.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StyleSelector; 